import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { AgentUploadLimitStrategy } from './agent-upload-limit-strategy'

@injectable()
export class LcaUploadLimitStrategy implements AgentUploadLimitStrategy {
    async getLimit(): Promise<number> {
        return 1
    }
}
